// extracted by mini-css-extract-plugin
export var attachmentContainer = "_s0-0";
export var fileList = "_s0-2";
export var removeFileButton = "_s0-1";